<div *ngIf="getDebugService().debug" class="debug-controls" [ngClass]="{'debug':getDebugService().debug}">
	<div class="debug-controls">
		<div>
			<button (click)="getDebugService().switchScreenLayout()">Switch Screen Layout</button>
		</div>
		<div>Current Screen Layout: <strong>{{ getDebugService().currentScreenLayout }}</strong></div>

	</div>
</div>
